import { render } from "./EmployeeDeniedLiquidations.vue?vue&type=template&id=478b9a7b"
import script from "./EmployeeDeniedLiquidations.vue?vue&type=script&lang=js"
export * from "./EmployeeDeniedLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__